import { DURUS_HASAR_TURU } from '@kurultay/tipler'
import type { Durus, HasarTuru } from '@kurultay/tipler'

export interface Beceri {
  kod: string
  ad: string
  durus: Durus
  ofkeMaliyeti: number
  /** Hasar çarpanı. 1 = temel saldırı. */
  carpan: number
  /** Ön saf korumasını atlar mı? */
  safDeler: boolean
  /** Kaç hedefe vurur? */
  hedefSayisi: number
}

function b(
  kod: string, ad: string, durus: Durus,
  ofkeMaliyeti: number, carpan: number,
  safDeler = false, hedefSayisi = 1,
): Beceri {
  return { kod, ad, durus, ofkeMaliyeti, carpan, safDeler, hedefSayisi }
}

/**
 * Faz 1: duruş başına iki beceri — biri bedava temel, biri öfkeli.
 *
 * ÇARPAN KURALI: alan becerilerinin çarpanı hedef sayısına bölünür.
 * Aksi halde 3 hedefe 1.2 çarpanla vuran beceri 3.6 etkin hasar yapar ve
 * tek hedefli becerileri tamamen gereksizleştirir (denge simülatörü bunu
 * %99.6'lık tek taraflı eşleşme olarak yakaladı).
 * Etkin hasar = carpan × hedefSayisi; temel saldırılar ~1.0-1.2 bandında tutulur.
 * Tam beceri ağaçları (meslek başına 8 aktif + 6 pasif) Faz 4'te gelir.
 */
export const BECERILER: Record<string, Beceri> = {
  // Alp · kılıç — savunmalı, sürekli
  kilic_vurus:   b('kilic_vurus', 'Kılıç Vuruşu', 'kilic', 0, 1.0),
  kalkan_duvari: b('kalkan_duvari', 'Kalkan Duvarı', 'kilic', 40, 1.4),

  // Alp · balta — ağır; fırlatma ile arka safa uzanır
  balta_savur:   b('balta_savur', 'Balta Savurma', 'balta', 0, 1.25),
  balta_firlat:  b('balta_firlat', 'Balta Fırlatma', 'balta', 50, 0.9, true),

  // Akıncı · ok — menzilli tek hedef
  ok_at:         b('ok_at', 'Ok Atma', 'ok', 0, 1.0),
  delici_ok:     b('delici_ok', 'Delici Ok', 'ok', 45, 1.3, true),

  // Akıncı · bıçak — yakın kritik
  bicak_sapla:   b('bicak_sapla', 'Bıçak Saplama', 'bicak', 0, 1.1),
  siyirma:       b('siyirma', 'Sıyırma', 'bicak', 50, 1.6),

  // Kam · büyü — alan ruh hasarı
  gok_gurultusu: b('gok_gurultusu', 'Gök Gürültüsü', 'buyu', 0, 0.55, false, 2),
  dolu_yagmuru:  b('dolu_yagmuru', 'Dolu Yağmuru', 'buyu', 60, 0.5, false, 3),

  // Kam · şifa — hasarı düşük; iyileştirme Faz 4'te gelecek
  kut_ufleme:    b('kut_ufleme', 'Kut Üfleme', 'sifa', 0, 0.5),
  sifa_ezgisi:   b('sifa_ezgisi', 'Şifa Ezgisi', 'sifa', 40, 0.3),

  // Kargıcı · tırpan — ön safa geniş ruh hasarı, zırhı yok sayar
  genis_bicme:   b('genis_bicme', 'Geniş Biçme', 'tirpan', 0, 0.4, false, 3),
  ruh_savurma:   b('ruh_savurma', 'Ruh Savurma', 'tirpan', 55, 0.5, false, 3),

  // Kargıcı · cirit — menzilli fiziksel, safı deler
  cirit_at:      b('cirit_at', 'Cirit Atma', 'cirit', 0, 1.0, true),
  delen_atis:    b('delen_atis', 'Delen Atış', 'cirit', 50, 1.35, true),
}

export function durusaGoreBeceriler(durus: Durus): Beceri[] {
  return Object.values(BECERILER).filter((b) => b.durus === durus)
}

export function kullanilabilirBeceriler(durus: Durus, ofke: number): Beceri[] {
  return durusaGoreBeceriler(durus).filter((b) => b.ofkeMaliyeti <= ofke)
}

/** Becerinin hasar türü, kullanıldığı duruştan gelir. */
export function beceriHasarTuru(beceri: Beceri): HasarTuru {
  return DURUS_HASAR_TURU[beceri.durus]
}
